<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @optionChange="optionChange" :pageData="pageData"></table-page>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '../components/page/table.vue'
    import FORM from '../components/page/form.vue'

    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import AUTH from '@/views/mis/util/auth'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'

    const requestOptions = {
	    headers: {"Content-Type": "application/json"},
        responseType: "blob",
    }

    const statusList = {
        "-1": window.$t('mis.agent.isValidFalse'),
        "0" : window.$t('mis.agent.isValidDefault'),
        "1" : window.$t('mis.agent.isValidTrue')
    }

    const statusOptionList = [
        {key: 0, value: statusList["0"]},
        {key: -1, value: statusList["-1"]},
        {key: 1, value: statusList["1"]},
    ];

    let originalTableData = [];

    export default {
        name: 'list',
        components: {
            tablePage,
            FORM
        },
        methods: {
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if("查询" == clickName || window.$t('mis.bt.query') == clickName){
                    if(data.timeRange != undefined && data.timeRange.length > 0) {
                        let { timeRangeStart, timeRangeEnd, timeRange, ...rest } = data;
                        this.queryData = rest;
                        this.queryData.fromTime = DateUtil.formatDate(timeRangeStart, "yyyy-MM-dd hh:mm:ss");
                        this.queryData.toTime = DateUtil.formatDate(timeRangeEnd, "yyyy-MM-dd hh:mm:ss");
                    } else {
                        this.queryData = data;
                    }
                    // console.log("queryData", this.queryData);
                    this.$refs.childTable.defaultQueryData(this.queryData);
                } else if(window.$t('mis.bt.export') == clickName) {
                    this.confirmAction(clickName, "export");
                } else if(window.$t('mis.bt.down') == clickName) {
                    this.confirmAction(clickName, "download");
                }
            },
            confirmAction(clickName, action) {
                this.$confirm(window.$t('mis.agent.confirmDownload'), window.$t('mis.agent.confirmMessageTitle'), {
                confirmButtonText: window.$t('mis.agent.confirmButton'),
                cancelButtonText: window.$t('mis.agent.cancleButton'),
                type: 'warning'
                }).then(() => {
                    this.requestExcel(action);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: window.$t('mis.agent.cancleMessage') + clickName
                    });          
                });
            },
            requestExcel(action) {
                let url = URL.agent.download;
                if("export" == action) {
                    url = URL.agent.export;
                }
                let {pageSize, pageNum, ...params} = this.queryData;
                this.$axios.post(url, JSON.stringify(params), requestOptions).then((res) => {
                    const data = res.data == null ? res : res.data;
                    const blob =new Blob([data], { type: 'application/vnd.ms-excel' });
                    
                    const href = window.URL.createObjectURL(blob);
                    
                    const anchorElement = document.createElement('a');
                    
                    anchorElement.href = href;

                    // 1) Get the value of content-disposition header
                    const contentDisposition = res.headers == null ? "" : res.headers['Content-Disposition'];
                    // console.log('contentDisposition: ', contentDisposition);

                    // 2) set the fileName variable to the default value
                    let fileName = "agent_"+action+"_excel_"+ Date.now() +".xlsx";

                    // 3) if the header is set, extract the filename
                    if (contentDisposition) {
                        const fileNameMatch =
                        contentDisposition.match(/filename="(.+)"/);
                        // console.log('fileNameMatch', fileNameMatch);
                        if (fileNameMatch.length === 2) {
                        fileName = fileNameMatch[1];
                        }
                    }

                    anchorElement.download = fileName;

                    document.body.appendChild(anchorElement);
                    anchorElement.click();

                    document.body.removeChild(anchorElement);
                    window.URL.revokeObjectURL(href);    
                }).catch(err => {
                    console.error(err);
                })
            },
            optionChange(row, val) {
                if(val != '' || val == 0) {
                    this.$confirm(window.$t('mis.agent.confirmValidate'), window.$t('mis.agent.confirmMessageTitle'), {
                    confirmButtonText: window.$t('mis.agent.confirmButton'),
                    cancelButtonText: window.$t('mis.agent.cancleButton'),
                    type: 'warning'
                    }).then(() => {
                        this.validate(row.id, val);
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: window.$t('mis.agent.cancleMessage')
                        });
                        this.$refs.childTable.rollbackTableData();
                    });
                }
            },
            validate(id, val) {
                let url = URL.agent.validate + "/" + id;
                this.$axios.get(url, { params: { isValid: val } }).then(res=> {
                    if (res.code == 0 && res.result == true) {
                        this.$message.success("Successfully Updated.");
                        this.$refs.childTable.defaultQueryData();
                    }else{
                        this.$message.error(res.message);
                    }
                });
            }
        },
        data () {
            return {
                queryData:{},
                /*from查询表单*/
                formData:{
                  hasLable: true,
                  cols:[
                      { title: window.$t('mis.agent.name'), field: 'name'},
                      { title: window.$t('mis.agent.identityCardNumber'), field: 'identityNo'},
                      { title: window.$t('mis.agent.phoneNumber'), field: 'phone'},
                      { title: window.$t('mis.agent.emailAddress'), field: 'email'},
                      { title: window.$t('mis.agent.qqAccount'), field: 'qqAccount'},
                      { title: window.$t('mis.agent.wechatAccount'), field: 'wechatAccount'},
                      { title: window.$t('mis.agent.companyName'), field: 'companyName'},
                      { title: window.$t('mis.agent.createdTime'), field: 'timeRange', type: 6},
                      { title: window.$t('mis.agent.isValid'), field: 'isValid', type: 2, optionList:statusOptionList, isNumber: true, placeholder: window.$t('mis.agent.isValidPlaceholder')},
                      { click: window.$t('mis.bt.query')},
                      { click: window.$t('mis.bt.export'), auth: "mis:agent:export"},
                      { click: window.$t('mis.bt.down'), auth: "mis:agent:download"}
                  ]
                },
                /*table生成*/
                pageData: {
                    method: "post",
                    fieldTotal: "recordsFiltered",
                    fieldData: "data",
                    isShow: false,
                    queryUrl: URL.agent.query, //请求路径和参数
                    sequence: true,
                    cols: [
                        { title: window.$t('mis.agent.name'), field: 'name'},
                        { title: window.$t('mis.agent.identityCardNumber'), field: 'identityNo'},
                        { title: window.$t('mis.agent.phoneNumber'), field: 'phone'},
                        { title: window.$t('mis.agent.emailAddress'), field: 'email'},
                        { title: window.$t('mis.agent.qqAccount'), field: 'qqAccount'},
                        { title: window.$t('mis.agent.wechatAccount'), field: 'wechatAccount'},
                        { title: window.$t('mis.agent.companyName'), field: 'companyName'},
                        { title: window.$t('mis.agent.companyLink'), field: 'companyLink'},
                        { title: window.$t('mis.agent.isValid'), field: 'isValid', optionList: statusOptionList, isNumber: true, auth: AUTH.isAuth("mis:agent:validate"), render(val, row) {
                            return statusList[`${val}`];
                        }},
                        { title: window.$t('mis.agent.createdTime'), field: 'createdTime'}
                    ]
                }
            }
        }
    }
</script>
